// extracted by mini-css-extract-plugin
export default {"image":"spousal-module__image--hjZ","text":"spousal-module__text--Kau","cta-group":"spousal-module__cta-group--pr4","ctaGroup":"spousal-module__cta-group--pr4"};